import React from "react";
import Axios from 'axios'
import MasterTemplate from "./MasterTemplate";
import API from '../Utils/api'


export class ConfigGiro extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            gerentes: [],
            gerentesSelecionados: []
        };
        this.getGerentes()
        this.getGerentesDoGiro()
    }

    getGerentes = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("usuarios/listar-todos-gerentes-ativos", {
            });
            this.setState({ gerentes: [this.state.user, ...response.data].sort(this.compararNome) });
            console.log(this.state.gerentes)

        } catch (err) {
            console.log(err);
        }
    };

    async getGerentesDoGiro() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.get("parametros/get-gerentes-giro");
            this.setState({ gerentesSelecionados: response.data.gerentesDoGiro });

        } catch (err) {
            console.log(err);
        }
    };

    reajustArray() {
        var inputGerentes = Object.entries(document.getElementsByName('gerentes'));
        var gSelecionados = []
        inputGerentes.map(input => {
            if (input[1].value > 0) {
                for (var x = 0; x < input[1].value; x++) {
                    gSelecionados.push(this.state.gerentes[input[1].accessKey]._id)
                }
            }
        })
        this.setState({ gerentesSelecionados: gSelecionados })
        this.updateGerentesDoGiro(gSelecionados);
    }
    contabilizarArray(gerente) {
        var score = 0;
        this.state.gerentesSelecionados.map(g => {
            if (g === gerente._id) {
                score++;
            }
        })
        return score;
    }

    async updateGerentesDoGiro(gerentesDoGiro) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem("apiUrl")
            });
            const response = await axiosInstance.post("parametros/update-gerentes-giro", { gerentesDoGiro: gerentesDoGiro });
        } catch (err) {
            console.log(err);
        }
    };

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }


    render() {
        return (
            <MasterTemplate label={'Configuração do Giro'}>

                <h4 className="text-danger">Total de giros: {this.state.gerentesSelecionados.length}</h4>
                <br />
                {this.state.gerentes.map((gerente, index) => {
                    return <div className='row mt-1'>
                        <div className='col'>                        <span class="text-black">{gerente.nome}</span></div>
                        <div className='col'>                        <input type="number" name="gerentes" className='inputNumber text-center' onChange={this.reajustArray.bind(this)} accessKey={index} placeholder="0" value={this.contabilizarArray(gerente)} /></div>
                    </div>
                })}

            </MasterTemplate>
        );
    }
}

export default ConfigGiro;
